import { Component } from '@angular/core';
import { PaymentMethod } from 'src/app/core/enums/payment-method.model';
import { ErrorService } from '../../services/error.service';

@Component({
	selector: 'app-error',
	templateUrl: './error.component.html',
	styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
	PaymentMethod = PaymentMethod;
	public statusCodePayError: string[] = [
		'101',
		'102',
		'104',
		'106',
		'107',
		'109',
		'110',
		'112',
		'114',
		'116',
		'117',
		'118',
		'119',
		'120',
		'121',
		'122',
		'123',
		'124',
		'125',
		'126',
		'129',
		'130',
		'160',
		'161',
		'167',
		'TPV-PC_EMV0007',
	];

	//OPERATION_CANCELLED --> 000: Error al intentar pagar o inicializar el método de pago
	//OPERATION_DENIED --> 001: Operación denegada
	//OPERATION_CANCELLED --> 002: Operación cancelada

	constructor(public errorService: ErrorService) {}

	ngOnInit(): void {}

	checkCodeStatus(): string {
		let statusCode = '';

		const found = this.statusCodePayError.find(
			(code) =>
				this.errorService.getErrorPayCause().includes(code) &&
				(!this.errorService.getErrorPayCause().includes('000') ||
					!this.errorService.getErrorPayCause().includes('001') ||
					!this.errorService.getErrorPayCause().includes('002')),
		);
		if (found) {
			statusCode = found;
		} else {
			if (this.errorService.getErrorPayCause().includes('000')) {
				statusCode = 'OPERATION_CANCELLED';
			} else if (this.errorService.getErrorPayCause().includes('001')) {
				statusCode = 'OPERATION_DENIED';
			} else if (this.errorService.getErrorPayCause().includes('002')) {
				statusCode = 'OPERATION_CANCELLED2';
			} else {
				statusCode = 'OPERATION_CANCELLED';
			}
		}

		return statusCode;
	}
}
